import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=5687d010&"
import script from "./splash.vue?vue&type=script&lang=js&"
export * from "./splash.vue?vue&type=script&lang=js&"
import style0 from "./splash.vue?vue&type=style&index=0&id=5687d010&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports